/*
 * currency-fix.js — enforces local-currency formatting on bundle-deals prices.
 *
 * The bundle logic in secondary.js multiplies shop-base-currency cents by discount
 * factors and formats the result with the active currency symbol, but without
 * applying Shopify Markets' currency conversion rate. That produces "£19.99"
 * when the true converted price is ~£15.84.
 *
 * This module re-renders every bundle price span from the raw cents values and
 * formats them via Intl.NumberFormat using window.Shopify.currency.active and
 * Shopify.currency.rate. It runs once on load and re-runs after any bundle
 * interaction (checkbox, variant select) in the next tick, so it overrides
 * whatever secondary.js wrote.
 */
(function () {
  'use strict';

  function shopifyCurrency() {
    var s = window.Shopify || {};
    var c = s.currency || {};
    return {
      active: c.active || (s.shop && s.shop.currency) || 'USD',
      rate: parseFloat(c.rate || '1') || 1,
    };
  }

  function locale() {
    return (document.documentElement.lang || 'en').replace('_', '-');
  }

  function formatMoney(baseCents) {
    if (baseCents == null || isNaN(baseCents)) return '';
    var cur = shopifyCurrency();
    var amount = (Number(baseCents) / 100) * cur.rate;
    try {
      return new Intl.NumberFormat(locale(), {
        style: 'currency',
        currency: cur.active,
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + cur.active;
    }
  }

  function parseFloatAttr(el, attr) {
    if (!el) return NaN;
    var v = el.getAttribute(attr);
    if (v == null) return NaN;
    return parseFloat(String(v).trim());
  }

  function reformatStaticSpans(root) {
    var spans = root.querySelectorAll('[data-price-raw]');
    spans.forEach(function (span) {
      var raw = parseFloatAttr(span, 'data-price-raw');
      if (!isFinite(raw)) return;
      if (
        span.classList.contains('bundle-deals__compare-price-js') ||
        span.classList.contains('bundle-deals__total-compare-price-js')
      ) {
        var sibling = span.parentNode.querySelector('.bundle-deals__price-js, .bundle-deals__total-price-js');
        var regularRaw = sibling ? parseFloatAttr(sibling, 'data-price-raw') : NaN;
        if (isFinite(regularRaw) && raw <= regularRaw) {
          span.textContent = '';
          return;
        }
      }
      span.textContent = formatMoney(raw);
    });
  }

  function recomputeBundle(bundleEl) {
    var percentageLeft = parseFloat(bundleEl.getAttribute('data-percentage-left')) || 1;
    var fixedDiscount = parseFloat(bundleEl.getAttribute('data-fixed-discount')) || 0;

    var totalPrice = 0;
    var totalCompare = 0;

    bundleEl.querySelectorAll('.bundle-deals__product-js').forEach(function (row) {
      if (row.getAttribute('data-coming-soon') === 'true') return;
      var checkbox = row.querySelector('.bundle-deals__checkbox-js');
      if (!checkbox || checkbox.disabled) return;
      var isChecked = checkbox.checked;

      var priceSpan = row.querySelector('.bundle-deals__price-js');
      var compareSpan = row.querySelector('.bundle-deals__compare-price-js');

      var rowPrice = parseFloatAttr(priceSpan, 'data-price-raw');
      var rowCompare = parseFloatAttr(compareSpan, 'data-price-raw');

      if (priceSpan && isFinite(rowPrice)) priceSpan.textContent = formatMoney(rowPrice);
      if (compareSpan) {
        if (isFinite(rowCompare) && isFinite(rowPrice) && rowCompare > rowPrice) {
          compareSpan.textContent = formatMoney(rowCompare);
        } else {
          compareSpan.textContent = '';
        }
      }

      if (isChecked) {
        if (isFinite(rowPrice)) totalPrice += rowPrice;
        if (isFinite(rowCompare)) totalCompare += rowCompare;
      }
    });

    var discountedTotal = totalPrice * percentageLeft - fixedDiscount;
    if (discountedTotal < 0) discountedTotal = 0;

    var totalSpan = bundleEl.querySelector('.bundle-deals__total-price-js');
    var totalCompareSpan = bundleEl.querySelector('.bundle-deals__total-compare-price-js');
    if (totalSpan) totalSpan.textContent = formatMoney(discountedTotal);
    if (totalCompareSpan) {
      if (totalCompare > discountedTotal) {
        totalCompareSpan.textContent = formatMoney(totalCompare);
      } else {
        totalCompareSpan.textContent = '';
      }
    }
  }

  function scheduleRecompute(bundleEl) {
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        recomputeBundle(bundleEl);
      }, 0);
    });
  }

  function initBundle(bundleEl) {
    recomputeBundle(bundleEl);
    bundleEl.addEventListener('change', function () {
      scheduleRecompute(bundleEl);
    });
    bundleEl.addEventListener('click', function (e) {
      if (e.target.closest('.bundle-deals__checkbox-label')) {
        scheduleRecompute(bundleEl);
      }
    });
  }

  function init() {
    document.querySelectorAll('bundle-deals').forEach(initBundle);
    reformatStaticSpans(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
